import { API_Version, ResultObj, permisionURL, getApiVersionJSON } from "./Domain";
import XLSX from "xlsx";
import { Appointment } from "./controller/Appointment";
import { Audit } from "./controller/Audit";
import { Bulletin } from "./controller/Bulletin";
import { Calendar } from "./controller/Calendar";
import { Car } from "./controller/Car";
import * as CarTS from "./controller/CarTS";
import { CarNotification } from "./controller/CarNotification";
import { CarPart } from "./controller/CarPart";
import * as CarPartTS from "./controller/CarPartTS";
import { CarStock } from "./controller/CarStock";
import * as CarStockTS from "./controller/CarStockTS";
import * as CarSubsidyTS from "./controller/CarSubsidyTS";
import { CarType } from "./controller/CarType";
import * as CarTypeTS from "./controller/CarTypeTS";
import { CarWarehouse } from "./controller/CarWarehouse";
import * as CarWarehouseTS from "./controller/CarWarehouseTS";
import { Commodity } from "./controller/Commodity";
import * as CommodityTS from "./controller/CommodityTS";
import { Company } from "./controller/Company";
import * as CompanyTS from "./controller/CompanyTS";
import * as CourseScheduleTS from "./controller/CourseScheduleTS";
import * as CourseSettingTS from "./controller/CourseSettingTS";
import { Customer } from "./controller/Customer";
import * as CustomerTS from "./controller/CustomerTS";
import { CustomerCSS } from "./controller/CustomerCSS";
import { Currency } from "./controller/Currency";
import * as CalendarTS from './controller/CalendarTS'
import * as CurrencyTS from "./controller/CurrencyTS";
import { DispatchCompany } from "./controller/DispatchCompany";
import * as DispatchCompanyTS from "./controller/DispatchCompanyTS";
import { EmployeeRules } from "./controller/EmployeeRules";
import { Files } from "./controller/Files";
import * as FilesTS from './controller/FilesTS'
import { GetApiInfo } from "./controller/GetApiInfo";
import { HintBell } from "./controller/HintBell";
import * as IncomeClassificationTS from "./controller/IncomeClassificationTS";
import { Import } from "./controller/Import";
import * as ImportTS from "./controller/ImportTS";
import { ImportData } from "./controller/ImportData";
import * as ImportDataTS from "./controller/ImportDataTS";
import * as InTimeInventoryTS from "./controller/InTimeInventoryTS"
import { Invoice } from "./controller/Invoice";
import * as InvoiceTS from "./controller/InvoiceTS";
import * as Insurance from './controller/Insurance';
import { Leave } from "./controller/Leave";
import { Meal } from "./controller/Meal";
import * as MealTS from "./controller/MealTS";
import { MealDetail } from "./controller/MealDetail";
import { MealPlace } from "./controller/MealPlace";
import * as MealPlaceTS from "./controller/MealPlaceTS";
import { MealPlaceDetail } from "./controller/MealPlaceDetail";
import * as  MealPlaceDetailTS from "./controller/MealPlaceDetailTS";
import { MealPlaceOther } from "./controller/MealPlaceOther";
import * as MealPlaceOtherTS from "./controller/MealPlaceOtherTS";
import { MealServiceBell } from "./controller/MealServiceBell";
import { MeetingRoom } from "./controller/MeetingRoom";
import * as MeetingRoomTS from "./controller/MeetingRoomTS";
import { MOSReport } from "./controller/MOSReport";
import * as MOSReportTS from "./controller/MOSReportTS";
import { MarketingActivity } from "./controller/MarketingActivity";
import * as MarketingActivityTS from "./controller/MarketingActivityTS";
import { MaintainStatus } from "./controller/MaintainStatus";
import * as NotificationTS from "./controller/NotificationTS";
import { PanelPaintOrder } from "./controller/PanelPaintOrder";
import * as PanelPaintOrderTS from './controller/PanelPaintOrderTS'
import { PanelPaintSetting } from "./controller/PanelPaintSetting";
import * as PanelPaintSettingTS from './controller/PanelPaintSettingTS'
import { Page } from "./controller/Page";
import { PDIOrder } from "./controller/PDIOrder";
import * as PDIOrderTS from "./controller/PDIOrderTS";
import { PDIProcedure } from "./controller/PDIProcedure";
import { PDIProcedureKT } from "./controller/PDIProcedureKT";
import { PDIWorkstation } from "./controller/PDIWorkstation";
import { PermissionFunction } from "./controller/PermissionFunction";
import * as PerformanceTS from "./controller/PerformanceTS"
import { Printer } from "./controller/Printer";
import * as PrinterTS from "./controller/PrinterTS";
import { Purchase } from "./controller/Purchase";
import * as PurchaseTS from "./controller/PurchaseTS";
import { Questionnaire } from "./controller/Questionnaire";
import { QuestionnaireLog } from "./controller/QuestionnaireLog";
import { QuestionnaireSetting } from "./controller/QuestionnaireSetting";
import { Quotation } from "./controller/Quotation";
import * as QuotationTS from "./controller/QuotationTS";
import { Report } from "./controller/Report";
import * as ReportTS from "./controller/ReportTS";
import { ScheduleClass } from "./controller/ScheduleClass";
import { SignOffLog } from "./controller/SignOffLog";
import * as SignOffLogTS from "./controller/SignOffLogTS";
import { SignOffSetting } from "./controller/SignOffSetting";
import * as SignOffSettingTS from "./controller/SignOffSettingTS";
import { Stock } from "./controller/Stock";
import * as StockTS from "./controller/StockTS";
import { SystemParam } from "./controller/SystemParam";
import * as SystemParamTS from "./controller/SystemParamTS";
import * as ScheduleClassTS from './controller/ScheduleClassTS'
import { SystemSettings } from "./controller/SystemSettings";
import * as SystemSettingsTS from "./controller/SystemSettingsTS";
import { Tax } from "./controller/Tax";
import * as TaxTS from "./controller/TaxTS";
import { TI_ImportData } from "./controller/TI_ImportData";
import { TI_MatchExcelSetting } from "./controller/TI_MatchExcelSetting";
import { TI_QuestionSetting } from "./controller/TI_QuestionSetting";
import * as TestDriveTS from './controller/TestDriveTS';
import * as OrderTS from "./controller/OrderTS";
import * as PotentialCustomerTS from "./controller/PotentialCustomerTS";
import * as PotentialCustomerTS_2 from "./controller/PotentialCustomerTS_2";
import * as CarComponentTS from "./controller/CarComponentTS";
import * as AuditTS from "./controller/AuditTS";
import { TelephoneInterviewLog } from "./controller/TelephoneInterviewLog";
import { ToDoList } from "./controller/ToDoList";
import * as ToDoListTS from "./controller/ToDoListTS";
import { TollItem } from "./controller/TollItem";
import * as TollItemTS from "./controller/TollItemTS";
import { TurnoverRepair } from "./controller/TurnoverRepair";
import * as TurnoverRepairTS from './controller/TurnoverRepairTS'
import { User } from "./controller/User";
import { UserControl } from "./controller/UserControl";
import * as UserTS from "./controller/UserTS";
import { UserCareerRank } from "./controller/UserCareerRank";
import * as UserCareerRankTS from './controller/UserCareerRankTS'
import { UserCustom } from "./controller/UserCustom";
import { UserDuty } from "./controller/UserDuty";
import * as UserDutyTS from "./controller/UserDutyTS";
import { UserLevel } from "./controller/UserLevel";
import * as UserLevelTS from './controller/UserLevelTS'
import { UserSalaryLog } from "./controller/UserSalaryLog";
import { UserSalarySetting } from "./controller/UserSalarySetting";
import { UserWork } from "./controller/UserWork";
import * as UserWorkTS from "./controller/UserWorkTS";
import { Warehouse } from "./controller/Warehouse";
import * as WarehouseTS from "./controller/WarehouseTS";
import { WorkAction } from "./controller/WorkAction";
import * as WorkActionTS from "./controller/WorkActionTS";
import { WorkHoursRule } from "./controller/WorkHoursRule";
import * as WorkHoursRuleTS from './controller/WorkHoursRuleTS';
import { WorkOrder } from "./controller/WorkOrder";
import * as WorkOrderTS from "./controller/WorkOrderTS";
import * as LeaveTS from "./controller/LeaveTS"
import * as UserSalaryLogTS from './controller/UserSalaryLogTS'
import * as UserCustomTS from './controller/UserCustomTS'
import * as QuestionnaireSettingTS from './controller/QuestionnaireSettingTS'
import * as PermissionFunctionTS from './controller/PermissionFunctionTS'
import * as QuestionnaireLogTS from './controller/QuestionnaireLogTS'
import { QuestionTypeEnum, CosmeticVenueStatusEnum, DDMenuItem } from "./types";


export {
    Appointment,
    Audit,
    AuditTS,
    Bulletin,
    Calendar,
    CalendarTS,
    Car,
    CarNotification,
    CarPart,
    CarPartTS,
    CarStock,
    CarStockTS,
    CarSubsidyTS,
    CarTS,
    CarType,
    CarTypeTS,
    CarWarehouse,
    CarWarehouseTS,
    Commodity,
    CommodityTS,
    Company,
    CompanyTS,
    CourseScheduleTS,
    CourseSettingTS,
    Currency,
    CurrencyTS,
    Customer,
    CustomerTS,
    CustomerCSS,
    CarComponentTS,
    DispatchCompany,
    DispatchCompanyTS,
    EmployeeRules,
    Files,
    FilesTS,
    GetApiInfo,
    HintBell,
    Import,
    ImportData,
    ImportDataTS,
    InTimeInventoryTS,
    ImportTS,
    IncomeClassificationTS,
    Invoice,
    InvoiceTS,
    Insurance,
    Leave,
    LeaveTS,
    MaintainStatus,
    MarketingActivity,
    MarketingActivityTS,
    Meal,
    MealTS,
    MealDetail,
    MealPlace,
    MealPlaceTS,
    MealPlaceDetail,
    MealPlaceDetailTS,
    MealPlaceOther,
    MealPlaceOtherTS,
    MealServiceBell,
    MeetingRoom,
    MeetingRoomTS,
    MOSReport,
    MOSReportTS,
    NotificationTS,
    OrderTS,
    Page,
    PDIOrder,
    PDIOrderTS,
    PDIProcedure,
    PDIProcedureKT,
    PDIWorkstation,
    PermissionFunction,
    PermissionFunctionTS,
    PerformanceTS,
    PanelPaintOrder,
    PanelPaintOrderTS,
    PanelPaintSetting,
    PanelPaintSettingTS,
    Printer,
    PrinterTS,
    Purchase,
    PurchaseTS,
    PotentialCustomerTS,
    PotentialCustomerTS_2,
    Questionnaire,
    QuestionnaireLog,
    QuestionnaireLogTS,
    QuestionnaireSetting,
    QuestionnaireSettingTS,
    Quotation,
    QuotationTS,
    Report,
    ReportTS,
    ScheduleClass,
    ScheduleClassTS,
    SignOffLog,
    SignOffLogTS,
    SignOffSetting,
    SignOffSettingTS,
    Stock,
    StockTS,
    SystemParam,
    SystemParamTS,
    SystemSettings,
    SystemSettingsTS,
    Tax,
    TaxTS,
    TelephoneInterviewLog,
    TI_ImportData,
    TI_MatchExcelSetting,
    TI_QuestionSetting,
    ToDoList,
    ToDoListTS,
    TollItem,
    TollItemTS,
    TurnoverRepair,
    TurnoverRepairTS,
    TestDriveTS,
    User,
    UserCareerRank,
    UserCareerRankTS,
    UserControl,
    UserCustom,
    UserCustomTS,
    UserDuty,
    UserDutyTS,
    UserLevel,
    UserLevelTS,
    UserSalaryLog,
    UserSalaryLogTS,
    UserSalarySetting,
    UserTS,
    UserWork,
    UserWorkTS,
    Warehouse,
    WarehouseTS,
    WorkAction,
    WorkActionTS,
    WorkHoursRule,
    WorkHoursRuleTS,
    WorkOrder,
    WorkOrderTS,
};


/** 拯救develop被汙染的事件 2022-07-27 15:40 Beck */

/**
 * 判斷要丟出去呼叫update相關的data有哪些是改過的
 * @param originalData 
 * @param updatedData 
 * @returns 
 */
export async function updateDataIfModified<T>(originalData: T, updatedData: T) {
    const modifiedFields: Partial<T> = {};

    for (const key in originalData) {
        if (Object.prototype.hasOwnProperty.call(originalData, key) && originalData[key] !== updatedData[key]) {
            modifiedFields[key] = updatedData[key];
        }
    }

    if (Object.keys(modifiedFields).length > 0) {
        return modifiedFields;
    } else {
        console.log('沒有變更任何資料');
    }
}

/**
 * 把物件裡面undefined的參數改變為指定的文字
 * @param obj 
 * @param text
 */
export function replaceUndefinedWithText(obj: Record<string, any>, text: string): Record<string, any> {
    let newObj = { ...obj }; // 創建一個物件的拷貝
    for (const key in newObj) {
        if (newObj[key] === undefined) {
            newObj[key] = text; // 將 undefined 替換為指定的文字
        }
    }
    return newObj;
}

/**
 * OptionList 裡面常出現的選單的類型
 */
export type OptionListType<K extends string = "value", T = string> = {
    name: string;
} & { [key in K]?: T };

/**
 * @description 選項
 */
export const OptionList = (() => {
    /**
     * @description 審核種類
     */
    let auditTypeArr = [
        "請假",
        "銷假",
        "加班",
        "撤銷加班",
        "調班",
        "撤銷調班",
        "資產轉移",
        "PDI流程審核",
        "PDI結案審核",
    ];
    let workPunchTypeArr = ["上班", "下班"];
    let workPunchIsvalidArr = [{ name: "有效", value: "Y" }, { name: "無效", value: "N" },];
    let statusArr = ["審核中", "審核通過", "審核不通過"];

    let punchCardStatusArr = [
        "正常",
        "休假",
        "上班未打卡",
        "下班未打卡",
        "曠職",
        "未排班",
        "遲到",
        "早退",
    ];
    let checkDaterangeTypesArr = ["排班", "請假", "加班", "調班"];
    let outer_order_processArrs = ["待掛牌", "待交車", "已退訂", "已交車"];

    /**
    * @description 人事-簽核/請購/請款 審核狀態類型
    */
    let signOffStatusOpts: OptionListType[] = [
        { name: "未送審", value: '' },
        { name: "審核中", value: '審核中' },
        { name: "審核通過", value: '審核通過' },
        { name: "審核不通過", value: '審核不通過' },
    ];
    /**
     * @description 假別類型
     */
    let leaveTypeArr = [
        { name: "期間限定", value: "期間限定" },
        { name: "一年給幾天系列", value: "一年給幾天系列" },
        { name: "特休", value: "特休" },
        { name: "補休", value: "補休" },
        { name: "其他", value: "其他" },
    ];
    /**
     * 是否提車
     */
    let isPickUpArr = [{ name: "已提車", value: "Y" }, { name: "未提車", value: "N" }];
    /**
     * @description 最小單位(天、小時)
     */
    let unitArr: OptionListType[] = [
        { name: "天", value: "天" },
        { name: "小時", value: "小時" },
    ];
    /**
     *  @description 是否可以
     */
    let canArr: OptionListType[] = [
        { name: "可以", value: "Y" },
        { name: "不可以", value: "N" },
    ];
    /**
     *  @description 狀態
     */
    let accountStatusArr: OptionListType[] = [
        { name: "停用", value: "Y" },
        { name: "正常", value: "N" },
    ];
    /**
     * @description 是否顯示選單
     */
    let visibleArr: OptionListType[] = [
        { name: "顯示", value: "Y" },
        { name: "隱藏", value: "N" },
    ];
    /**
     * @description 是否選單
     */
    let yesnoArr: OptionListType[] = [
        { name: "是", value: "Y" },
        { name: "否", value: "N" },
    ];
    /**
     * @description 是否選單(boolean)
     */
    let yesnoArrBool: OptionListType<"value", boolean>[] = [
        { name: "是", value: true },
        { name: "否", value: false },
    ];
    /**
     * @description 是否排程選單
     */
    let toDoListArr: OptionListType[] = [
        { name: "正常", value: "N" },
        { name: "已取消", value: "Y" },
    ];
    /**
     * @description 欄位類型選單
     */
    let typeArr: OptionListType[] = [
        { name: "簡答", value: "input" },
        { name: "日期", value: "date" },
        { name: "檔案", value: "file" },
    ];

    /**
     * @description 簽核欄位類型選單
     */
    let signOffColumnTypeArr: OptionListType[] = [
        { name: "文字", value: "文字" },
        { name: "多行文字", value: "多行文字" },
        { name: "數字", value: "數字" },
        { name: "年月日", value: "年月日" },
        { name: "年月日時分", value: "年月日時分" },
        { name: "檔案", value: "檔案" },
        { name: "選項", value: "選項" },
        { name: "配件", value: "配件" },
    ];

    /**
     * @description dotNet簽核欄位類型選單
     */
    const dotNetSignOffColumnTypeArr: OptionListType[] = [
        { name: "文字", value: "文字" },
        { name: "多行文字", value: "多行文字" },
        { name: "數字", value: "數字" },
        { name: "年月日", value: "年月日" },
        { name: "年月日時分", value: "年月日時分" },
        { name: "檔案", value: "檔案" },
        { name: "選項", value: "選項" },
    ];

    /**
     * @description 置頂選單
     */
    let isTopArr: OptionListType[] = [
        { name: "全部", value: "" },
        { name: "置頂", value: "Y" },
        { name: "非置頂", value: "N" },
    ];
    /**
     * @description 是否需已讀登入
     */
    let isLoginReadArr: OptionListType[] = [
        { name: "全部", value: "" },
        { name: "需已讀", value: "Y" },
        { name: "不需已讀", value: "N" },
    ];
    /**
     * @description 班表類型
     */
    let scTypeArr: OptionListType[] = [
        { name: "正常工時班表", value: "正常工時班表" },
        { name: "延長工時班表", value: "延長工時班表" },
    ];
    /**
     * @description 使用狀態
     */
    let isUseArr: OptionListType[] = [
        { name: "使用", value: "Y" },
        { name: "未使用", value: "N" },
    ];
    /**
     * @description 零件類型
     */
    let productTypeArr: OptionListType[] = [
        { name: "一般零件", value: "N" },
        { name: "組合零件", value: "Y" },
    ];
    /**
     * @description 批發零件買入方式
     */
    let purchaseBuyMethodArr: OptionListType[] = [
        { name: "零售", value: "零售" },
        { name: "批發", value: "批發" },
    ];
    /**
     * @description 驗收狀態
     */
    let ispaidArr: OptionListType[] = [
        { name: "尚未付款", value: "N" },
        { name: "付款完成", value: "Y" },
    ];
    /**
     * @description 驗收狀態
     */
    let isacceptanceArr: OptionListType[] = [
        { name: "未驗收", value: "N" },
        { name: "已驗收", value: "Y" },
    ];
    /**
     * @description 結案狀態
     */
    let iscompleteArr: OptionListType[] = [
        { name: "未結案", value: "N" },
        { name: "已結案", value: "Y" },
    ];
    /**
     * @description 發票開立狀態
     */
    let isInvoiceArr: OptionListType[] = [
        { name: "系統開立", value: "Y" },
        { name: "手寫開立", value: "N" },
    ];
    /**
     * @description 類別
     */
    let workTypeArr: OptionListType[] = [
        { name: "鈑金", value: "鈑金" },
        { name: "烤漆", value: "烤漆" },
        { name: "耗材", value: "耗材" },
        { name: "外包", value: "外包" },
    ];
    // /**
    //  * @description 進貨狀態
    //  */
    // let restockStatusArr: OptionListType[] = [{ name: "001", value: "N" }, { name: "組合商品", value: "Y" }];
    /**
     * @description 工單狀態
     */
    let workOrderStatusArr: OptionListType[] = [
        { name: "作廢", value: "作廢" },
        { name: "待修", value: "待修" },
        { name: "暫停", value: "暫停" },
        { name: "完工", value: "完工" },
        { name: "結案", value: "結案" },
    ];
    /**
     * @description 派工狀態
     */
    let dispatchStatusArr = [
        { name: "未派工", value: "未派工" },
        { name: "已派工未開工", value: "已派工未開工" },
        { name: "已開工", value: "已開工" },
        { name: "已停工", value: "已停工" },
        { name: "已完成", value: "已完成" },
    ];
    /**
     * @description 沖帳狀態
     */
    let isStrikeBalanceArr: OptionListType[] = [
        { name: "未沖帳", value: "N" },
        { name: "已沖帳", value: "Y" },
    ];
    /**
     * @description 發票狀態
     */
    let isInvoiceInvalidArr: OptionListType[] = [
        { name: "已開立", value: "N" },
        { name: "已作廢", value: "Y" },
    ];
    /**
    * @description 優惠券狀態
    */
    let isCouponInvalidArr: OptionListType[] = [
        { name: "有效", value: "Y" },
        { name: "作廢", value: "N" },
    ];
    /**
     * @description 移庫狀態
     */
    let ischeckArr: OptionListType[] = [
        { name: "未接收", value: "N" },
        { name: "已接收", value: "Y" },
    ];
    /**
     * @description 歸還狀態
     */
    let isreturnArr: OptionListType[] = [
        { name: "未歸還", value: "N" },
        { name: "已歸還", value: "Y" },
    ];
    /**
     * @description 發布狀態
     */
    let releaseArr: OptionListType[] = [
        { name: "未發布", value: "N" },
        { name: "發布", value: "Y" },
    ];
    /**
     * @description 封存狀態
     */
    let sealArr: OptionListType[] = [
        { name: "未封存", value: "N" },
        { name: "封存", value: "Y" },
    ];
    /**
     * @description 報表類型
     */
    let calculateTypeArr: OptionListType[] = [
        { name: "簽約", value: "簽約" },
        { name: "掛牌", value: "掛牌" },
    ];
    /**
     * @description 限定保管人
     */
    let isCustodyOnlyArr: OptionListType[] = [
        { name: "申請人自己預約", value: "Y" },
        { name: "排除申請人", value: "N" },
        { name: "不限制", value: "" },
    ];

    /**
     * @description 公佈欄消息指定分類
     */
    let classificationArr: OptionListType[] = [
        { name: "公司", value: "COM" },
        { name: "高階管理階層", value: "GMO" },
        { name: "部門", value: "DEP" },
        { name: "廠別", value: "POS" },
        { name: "課級", value: "CLA" },
        { name: "組級", value: "GRP" },
        { name: "辦公室", value: "OFC" },
    ];

    // 排序順序 sort_order
    let sortOrderArr: OptionListType[] = [
        { name: "正序", value: "正" },
        { name: "倒序", value: "倒" },
    ];

    // 排序順序 sort_order str:[新舊]
    let sortOrderStrArr: OptionListType[] = [
        { name: "舊到新", value: "正" },
        { name: "新到舊", value: "倒" },
    ];

    /**
     * @description [鈑烤]表單列表依名排序選單
     */
    const PanelPaintSortNameArr: OptionListType[] = [
        { name: "延遲完工日", value: "延遲完工日" },
        { name: "進廠時間", value: "進廠時間" },
        { name: "完工時間", value: "完工時間" },
    ];

    // 是否完工
    const codeListIsComplete: OptionListType[] = [
        { name: "完工", value: "Y" },
        { name: "未完工", value: "N" },
    ]

    /**
     * @description [電訪]上傳的excel 欄位 資料型態
     */
    let MatchExcelDetailArr: OptionListType[] = [
        { name: "文字", value: "文字" },
        { name: "數字", value: "數字" },
        { name: "年月日", value: "年月日" },
        { name: "年月日時分", value: "年月日時分" },
    ];

    /**
     * @description [電訪]問題類型
     */
    let questionTypeArr: OptionListType[] = [
        { name: QuestionTypeEnum.TRUEORFALSE, value: QuestionTypeEnum.TRUEORFALSE },
        { name: QuestionTypeEnum.MULTIPLECHOICE, value: QuestionTypeEnum.MULTIPLECHOICE },
        { name: QuestionTypeEnum.MULTIPLECHOICEMORE, value: QuestionTypeEnum.MULTIPLECHOICEMORE },
        { name: QuestionTypeEnum.CLOZE, value: QuestionTypeEnum.CLOZE },
        { name: QuestionTypeEnum.LINEARSCALE, value: QuestionTypeEnum.LINEARSCALE },
    ];

    /**
     * @description [電訪]客服電訪狀態
     */
    let TILogStatusArr: OptionListType[] = [
        { name: "尚未去電", value: "尚未去電" },
        { name: "未接通1", value: "未接通1" },
        { name: "未接通2", value: "未接通2" },
        { name: "已接未訪1", value: "已接未訪1" },
        { name: "已接未訪2", value: "已接未訪2" },
        { name: "已接通", value: "已接通" },
        { name: "人工結案", value: "人工結案" },
        { name: "無需去電", value: "無需去電" },
        { name: "未接簡訊", value: "未接簡訊" },
        { name: "已接簡訊", value: "已接簡訊" },
    ];

    /**
     * @description [電訪]電訪結果
     */
    let TIResultArr: OptionListType[] = [
        { name: "電訪完成", value: "電訪完成" },
        { name: "電訪中", value: "電訪中" },
        { name: "未電訪", value: "未電訪" },
    ];

    /**
     * @description [電訪]後續處理項目
     */
    let TIStatusArr: OptionListType[] = [
        { name: "需簡訊", value: "需簡訊" },
        { name: "需預約", value: "需預約" },
        { name: "需回覆", value: "需回覆" },
        { name: "有意見", value: "有意見" },
        { name: "其他", value: "其他" },
    ];

    /**
     * @description [電訪]後續處理進度
     */
    let TIProcessArr: OptionListType[] = [
        { name: "未處理", value: "未處理" },
        { name: "處理中", value: "處理中" },
        { name: "已結案", value: "已結案" },
    ];

    // 薪資項目型態
    let salaryTypeArr: OptionListType[] = [
        { name: "應發", value: "應發" },
        { name: "應扣", value: "應扣" },
        { name: "數字", value: "數字" },
        { name: "文字", value: "文字" },
    ];

    /**
     * @description 表單類型
     */
    let QSMTypeArr: OptionListType[] = [{ name: "MOS", value: "MOS" }];
    /**
     * @description [表單]問題類型
     */
    let questionnaireTypeArr: OptionListType[] = [
        { name: QuestionTypeEnum.TRUEORFALSE, value: QuestionTypeEnum.TRUEORFALSE },
        { name: QuestionTypeEnum.MULTIPLECHOICE, value: QuestionTypeEnum.MULTIPLECHOICE },
        { name: QuestionTypeEnum.MULTIPLECHOICEMORE, value: QuestionTypeEnum.MULTIPLECHOICEMORE },
        { name: QuestionTypeEnum.CLOZE, value: QuestionTypeEnum.CLOZE },
    ];
    /**
     * @description 排班設定 假日列表 是否假日
     */
    let holidayTypeArr: OptionListType[] = [
        { name: "工作日", value: "N" },
        { name: "放假日", value: "Y" },
    ];
    /**
     * @description 保險廠商類型
     */
    let insuranceTypeArr: OptionListType[] = [
        { name: "保險", value: "保險" },
        { name: "外包", value: "外包" },
    ];

    // 車輛保留狀態
    let SMT_statusArr: OptionListType[] = [
        { name: "在庫車", value: "在庫車" },
        { name: "已接單", value: "已接單" },
        { name: "已交車", value: "已交車" },
    ];

    let SaleableArr: OptionListType[] = [
        { name: "開放", value: "Y" },
        { name: "取消", value: "N" },
    ];

    /**
     * @description [零件]採購查詢排序條件
     */
    let SortNamePurchaseArr: OptionListType[] = [
        { name: "採購時間", value: "採購時間" },
        { name: "建立時間", value: "建立時間" }
    ];

    /**
     * @description [零件]進貨查詢排序條件
     */
    let SortNameRestockArr: OptionListType[] = [
        { name: "進貨時間", value: "進貨時間" },
        { name: "建立時間", value: "建立時間" }
    ];

    /**
     * @description [零件]採購排序順序
     */
    let SortOrderArr: OptionListType[] = [
        { name: "新到舊", value: "倒" },
        { name: "舊到新", value: "正" },
    ];


    let CarSubsidyConditionDeductible: OptionListType[] = [
        { name: "可折", value: "可折" },
        { name: "不可折", value: "不可折" }
    ]

    let CarSubsidyConditionType: OptionListType[] = [
        { name: "現金", value: "現金" },
        { name: "配件", value: "配件" }
    ]

    let CarSubsidyConditionName: OptionListType[] = [
        { name: "不指定", value: "不指定" },
        { name: "限定車身碼", value: "限定車身碼" },
        { name: "保險", value: "保險" }
    ]

    let abnormal_sale_type: OptionListType[] = [
        { name: "無", value: "無" },
        { name: "員工購車", value: "員工購車" },
        { name: "租賃", value: "租賃" },
        { name: "公關車", value: "公關車" },
        { name: "其他", value: "其他" }
    ]

    let associateType: OptionListType[] = [
        { name: "成立", value: "成立" },
        { name: "不成立", value: "不成立" }
    ]
    /**
  * @description 異常銷售狀態選單
  */
    let AbnormalSaleType: OptionListType[] = [
        { name: '無', value: '無' },
        { name: '員工購車', value: '員工購車' },
        { name: '租賃', value: '租賃' },
        { name: '公關車', value: '公關車' },
        { name: '其他', value: '其他' }
    ];

    /**
    * @description 車輛是否停止配對
    */
    let IsDispatched: OptionListType[] = [
        { name: '正常', value: "N" },
        { name: '停止配對', value: "Y" }
    ];

    /**
   * @description 入金方式
   */
    let PaymentTypes: OptionListType[] = [
        { name: "匯款", value: "匯款" },
        { name: "支票", value: "支票" },
        { name: "刷卡", value: "刷卡" },
        { name: "貸款", value: "貸款" },
        { name: "內轉", value: "內轉" },
    ];

    /**
    *  @description 狀態
    */
    let checkStatusArr: OptionListType[] = [
        { name: "已確認", value: "Y" },
        { name: "未確認", value: "N" },
    ];

    /**
    *  @description 配車狀態
    */
    let dispatchedStatusArr: OptionListType[] = [
        { name: "已配車", value: "Y" },
        { name: "未配車", value: "N" },
    ];

    /**
   *  @description 審核狀態
   */
    let ApprovalStatusArr: OptionListType[] = [
        { name: "審核中", value: "審核中" },
        { name: "審核通過", value: "審核通過" },
        { name: "審核不通過", value: "審核不通過" },
    ];

    /**
     * @description [零件]庫存作業類型
     */
    let StockTypeArr: OptionListType[] = [
        { name: '退貨作業', value: '退貨' },
        { name: '調整作業', value: '調整' },
        { name: '調撥作業', value: '調撥' },
        { name: '驗收作業', value: '驗收' },
        { name: '訂單成立', value: '訂單成立' },
        { name: '訂單取消', value: '訂單取消' },
        { name: '工單退單', value: '工單退單' },
        { name: '退單取消', value: '退單取消' },
    ];

    /** @description 訂購類型 */
    let OrderType: OptionListType[] = [
        { name: '標配', value: '標配' },
        { name: '加選', value: '加選' },
    ]

    /** @description 車輛狀態 */
    let CarStatus: OptionListType[] = [
        { name: '現車', value: '現車' },
        { name: '遠期', value: '遠期' },
        { name: '特調', value: '特調' },
    ]

    /** @description 能源種類 */
    let EnergyType: OptionListType[] = [
        { name: '燃油', value: '燃油' },
        { name: '油電', value: '油電' },
        { name: '純電', value: '純電' },
    ]

    /** @description 購買方式 */
    let PurchaseMethod: OptionListType[] = [
        { name: '現金', value: '現金' },
        { name: '貸款', value: '貸款' },
        { name: '租賃', value: '租賃' },
    ]

    /** @description 車貸利息 */
    let LoanInterestMethod: OptionListType[] = [
        { name: '買方另付', value: '買方另付' },
        { name: '計入交易', value: '計入交易' },
    ]

    /** @description 有無選單*/
    let hasnotArr: OptionListType[] = [
        { name: "有", value: "Y" },
        { name: "無", value: "N" },
    ]
    /**
    * @description 潛客狀態
    */
    let PotentialStatusArr: OptionListType[] = [
        { name: '進行中', value: '進行中' },
        { name: '完成', value: '完成' },
        { name: '取消', value: '取消' },
        { name: '清除狀態', value: '清除狀態' },
    ];

    /**
    * @description 潛客關係類型
    */
    let LinkTypeArr: OptionListType[] = [
        { name: '父母', value: '父母' },
        { name: '婚姻關係', value: '婚姻關係' },
        { name: '子女', value: '子女' },
        { name: '親戚', value: '親戚' },
        { name: '伴侶', value: '伴侶' },
        { name: '朋友', value: '朋友' },
        { name: '同事', value: '同事' },
        { name: '其他', value: '其他' },
    ];

    /**
    * @description 潛客聯絡類型
    */
    let ContactTypeArr: OptionListType[] = [
        { name: '主要', value: '主要' },
        { name: '住家', value: '住家' },
        { name: '公司', value: '公司' },
        { name: '學校', value: '學校' },
        { name: '其他', value: '其他' },
    ];

    /**
    * @description 職業
    */
    let CareerTypeArr: OptionListType[] = [
        { name: '企業負責人', value: '企業負責人' },
        { name: '企業股東', value: '企業股東' },
        { name: '企業高級主管', value: '企業高級主管' },
        { name: '企業中級主管', value: '企業中級主管' },
        { name: '企業基層主管', value: '企業基層主管' },
        { name: '企業基層人員', value: '企業基層人員' },
        { name: '政府首長', value: '政府首長' },
        { name: '政府幹部', value: '政府幹部' },
        { name: '政府基層人員', value: '政府基層人員' },
        { name: '警官', value: '警官' },
        { name: '警員', value: '警員' },
        { name: '工讀生', value: '工讀生' },
        { name: '農林漁牧', value: '農林漁牧' },
        { name: '藝文/運動工作者', value: '藝文/運動工作者' },
        { name: '自營商店老闆', value: '自營商店老闆' },
        { name: '學生', value: '學生' },
        { name: '家管、退休人員、自我投資', value: '家管、退休人員、自我投資' },
        { name: '其它', value: '其它' },
    ];

    /**
    * @description 中華民國職業標準分類 第6次修訂(99年5月)
    */
    let CareerTypeArr2: OptionListType[] = [
        { name: '民意代表、主管及經理人員', value: '民意代表、主管及經理人員' },
        { name: '專業人員', value: '專業人員' },
        { name: '技術員及助理專業人員', value: '技術員及助理專業人員' },
        { name: '事務支援人員', value: '事務支援人員' },
        { name: '服務及銷售工作人員', value: '服務及銷售工作人員' },
        { name: '農、林、漁、牧業生產人員', value: '農、林、漁、牧業生產人員' },
        { name: '技藝有關工作人員', value: '技藝有關工作人員' },
        { name: '機械設備操作及組裝人員', value: '機械設備操作及組裝人員' },
        { name: '基層技術工及勞力工', value: '基層技術工及勞力工' },
    ];


    /**
    * @description 座位類型
    */
    let SeatTypeArr: OptionListType[] = [
        { name: '使用中座位', value: 'Y' },
        { name: '所有座位', value: 'N' },
    ];

    /** 庫存調整、庫存盤點 類型選單 */
    let samTypeArr: string[] = ["調整", "盤點"];


    /** 配件款項歸屬 */
    let PriceBelong = ["客戶付", "公司付", "總公司付"];

    /** 商品類型 */
    let CommodityTypeArr: string[] = ["零件", "配件", "設備"];

    /** 點名狀態  */
    enum RollCallStatusEnum {
        PRESENT = "到",
        ABSENT = "未到",
        LEAVE = "休假",
        OFFICALLEAVE = "公假",
    }

    /** 請購單狀態 */
    let TradeReceivableStatusArr: OptionListType[] = [
        { name: '尚未收款', value: '尚未收款' },
        { name: '收款中', value: '收款中' },
        { name: '下款中', value: '下款中' },
        { name: '下款完成', value: '下款完成' },
        { name: '已結案', value: '已結案' },
    ];

    /** 請購類別 */
    let RequisitionTypeArr: OptionListType[] = [
        { name: '請購單', value: '請購單' },
        { name: '報修單', value: '報修單' },
    ];

    /** [課題設定]經銷商與職務類別 */
    let CourseTargetTypeArr: OptionListType[] = [
        { name: '經銷商', value: '經銷商' },
        { name: '職務', value: '職務' },
    ];

    /** [課題設定]問題類型 */
    let AudiQuestionTypeArr: OptionListType[] = [
        { name: QuestionTypeEnum.TRUEORFALSE, value: QuestionTypeEnum.TRUEORFALSE },
        { name: QuestionTypeEnum.MULTIPLECHOICE, value: QuestionTypeEnum.MULTIPLECHOICE },
        { name: QuestionTypeEnum.MULTIPLECHOICEMORE, value: QuestionTypeEnum.MULTIPLECHOICEMORE },
    ];

    /** 美容預約狀態 */
    let CosmeticVenueStatusArr: OptionListType[] = [
        { name: CosmeticVenueStatusEnum.RESERVED, value: CosmeticVenueStatusEnum.RESERVED },
        { name: CosmeticVenueStatusEnum.CONFIRM, value: CosmeticVenueStatusEnum.CONFIRM },
        { name: CosmeticVenueStatusEnum.IMPLEMENT, value: CosmeticVenueStatusEnum.IMPLEMENT },
        { name: CosmeticVenueStatusEnum.COMPLETE, value: CosmeticVenueStatusEnum.COMPLETE },
        { name: CosmeticVenueStatusEnum.NOTENTERED, value: CosmeticVenueStatusEnum.NOTENTERED },
    ];

    /** [課題設定]問券類型 */
    let AudiSatisfactionQuestionTypeArr: OptionListType[] = [
        { name: QuestionTypeEnum.MULTIPLECHOICE, value: QuestionTypeEnum.MULTIPLECHOICE },
        // { name: QuestionTypeEnum.CLOZE, value: QuestionTypeEnum.CLOZE },
    ];

    /** 請款單匯出 exel type */
    let InvoicePaymentExcelModeArr: OptionListType[] = [
        { name: '系統預設', value: 'Default' },
        { name: '文中', value: 'Winton' },
    ];

    /** 優惠券來源資料表 列舉 */
    enum CouponDetailSourceEnum {
        Car = "Car",
        Customer = "Customer",
        WorkOrder = "WorkOrder"
    }

    /** 預約車輛來源資料表 列舉 */
    enum CarSourceEnum {
        /** cs_id */
        CarStock = "庫存車",
        /** car_id */
        Car = "有牌車",
    }

    /** 優惠券來源資料表 選單 */
    const codeListCouponDetailSource = [
        { name: "車籍", value: CouponDetailSourceEnum.Car },
        { name: "車主", value: CouponDetailSourceEnum.Customer },
        { name: "工單", value: CouponDetailSourceEnum.WorkOrder },
    ]

    /** 優惠券狀態 選單 */
    const codeListCouponDetailStatus = [
        { name: "未發行", value: "未發行" },
        { name: "未折抵", value: "未折抵" },
        { name: "已折抵", value: "已折抵" },
        { name: "已過期未折抵", value: "已過期未折抵" },
    ]

    /** 車輛售出對象選單 */
    const saleTargetArr = [
        { name: "消費者", value: "消費者" },
        { name: "經銷商", value: "經銷商" },
    ]

    /** 車輛買賣狀態選單 */
    const purchaseStatusArr = [
        { name: "買賣完成", value: "買賣完成" },
    ]

    /**請款對象選單 */
    const codeListInvoiceType = [
        { name: '廠商及員工請款', value: '廠商及員工請款' },
        { name: '租賃及客戶退付款和其他', value: '租賃及客戶退付款' },
    ]

    /**倉庫類型選單 */
    const WarehouseTypeArr = [
        { name: '一般', value: '一般' },
        { name: '販售', value: '販售' },
        { name: '退貨', value: '退貨' },
        { name: '報廢', value: '報廢' }
    ]

    return {
        unitArr,
        canArr,
        auditTypeArr,
        workPunchTypeArr,
        workPunchIsvalidArr,
        workOrderStatusArr,
        accountStatusArr,
        outer_order_processArrs,
        statusArr,
        punchCardStatusArr,
        checkDaterangeTypesArr,
        leaveTypeArr,
        isPickUpArr,
        visibleArr,
        yesnoArr,
        yesnoArrBool,
        toDoListArr,
        typeArr,
        signOffColumnTypeArr,
        dotNetSignOffColumnTypeArr,
        isTopArr,
        isLoginReadArr,
        scTypeArr,
        isUseArr,
        productTypeArr,
        purchaseBuyMethodArr,
        ispaidArr,
        isacceptanceArr,
        iscompleteArr,
        workTypeArr,
        isInvoiceArr,
        dispatchStatusArr,
        ischeckArr,
        isreturnArr,
        classificationArr,
        releaseArr,
        sealArr,
        calculateTypeArr,
        isCustodyOnlyArr,
        sortOrderArr,
        salaryTypeArr,
        MatchExcelDetailArr,
        questionTypeArr,
        TILogStatusArr,
        TIResultArr,
        TIStatusArr,
        TIProcessArr,
        sortOrderStrArr,
        QSMTypeArr,
        questionnaireTypeArr,
        holidayTypeArr,
        isStrikeBalanceArr,
        isInvoiceInvalidArr,
        isCouponInvalidArr,
        SMT_statusArr,
        insuranceTypeArr,
        SaleableArr,
        SortNamePurchaseArr,
        SortNameRestockArr,
        SortOrderArr,
        CarSubsidyConditionDeductible,
        CarSubsidyConditionType,
        CarSubsidyConditionName,
        abnormal_sale_type,
        associateType,
        AbnormalSaleType,
        IsDispatched,
        PaymentTypes,
        checkStatusArr,
        dispatchedStatusArr,
        ApprovalStatusArr,
        StockTypeArr,
        OrderType,
        CarStatus,
        EnergyType,
        PurchaseMethod,
        LoanInterestMethod,
        hasnotArr,
        PotentialStatusArr,
        ContactTypeArr,
        LinkTypeArr,
        CareerTypeArr,
        SeatTypeArr,
        samTypeArr,
        PriceBelong,
        CommodityTypeArr,
        RollCallStatusEnum,
        TradeReceivableStatusArr,
        RequisitionTypeArr,
        CourseTargetTypeArr,
        AudiQuestionTypeArr,
        CosmeticVenueStatusArr,
        AudiSatisfactionQuestionTypeArr,
        InvoicePaymentExcelModeArr,
        CouponDetailSourceEnum,
        codeListCouponDetailSource,
        codeListCouponDetailStatus,
        CarSourceEnum,
        saleTargetArr,
        purchaseStatusArr,
        PanelPaintSortNameArr,
        codeListIsComplete,
        codeListInvoiceType,
        signOffStatusOpts,
        WarehouseTypeArr
    };
})();

export const RegexList = (() => {
    const trs_id = /TRS([0-9]*)/gm;
    const qis_id = /QIS([0-9]*)/gm;
    const tellephone = /(\d{2,3}-?|\(\d{2,3}\))?(\d{3,4}-?\d{4})/gm; // 市話
    const cellephone = /((\+\d{2,3})?-?|0)9\d{2}(\d{6}|-\d{3}-\d{3})/gm; // 手機
    const phone =
        /(\d{2,3}-?|\(\d{2,3}\))?(\d{3,4}-?\d{4})|((\+\d{2,3})?-?|0)9\d{2}(\d{6}|-\d{3}-\d{3})/gm; // 市話+手機
    return {
        trs_id,
        qis_id,
        tellephone,
        cellephone,
        phone,
    };
})();

export const DDMenu = (() => {

    /**
     * @description 系統及選單代碼檔
     * @returns res
     */
    let selectorcode = async <T>(
        obj: { spp_id: string | null } = { spp_id: null }
    ): Promise<T[]> => {
        let { spp_id } = { ...obj };
        let defaultApiVersion: keyof typeof API_Version | null = localStorage.getItem("defaultApiVersion");

        // 若 localStorage 內無 defaultApiVersion，主動去抓取 api_version.json (避免 Race Condition 導致)
        if (!defaultApiVersion) {
            const api_version_set = await getApiVersionJSON();
            if (api_version_set !== null) {
                defaultApiVersion = api_version_set.defaultApiVersion;
                localStorage.setItem("defaultApiVersion", defaultApiVersion);
            }
        }

        if (defaultApiVersion === "dotNet6" || defaultApiVersion === "dotNet6_AM_N") {
            if (spp_id !== null) {
                const result = await SystemParamTS.SecondList({ spp_id, visible: 'Y' });
                if (result.success) return result.data as T[];
                else return [];
            } else {
                return [];
            }
        } else if (defaultApiVersion === "framework") {
            if (!!sessionStorage.company_code) {
                try {
                    return await fetch(`${permisionURL}/_${sessionStorage.company_code}/DDMenu/${spp_id}.json?x=` + Date.now())
                        .then((r) => r.json());
                } catch (error) {
                    console.error("找不到代碼檔", error);
                    return [];
                }
            } else {
                console.warn("沒有公司代碼，暫停取得代碼檔")
            }
        } return [];
    };

    /**
     * @description 系統及選單代碼檔
     * @returns res
     */
    let nestcode = async <T = any>(
        obj: { menuName: string | null } = { menuName: null }
    ): Promise<T[]> => {
        let { menuName } = { ...obj };
        try {
            if (!!menuName) {
                return await fetch(`${permisionURL}/_${sessionStorage.company_code}/DDMenu/${menuName}.json?x=` + Date.now())
                    .then((r) => r.json());
            } else {
                return [];
            }
        } catch (error) {
            console.error("找不到代碼檔", error);
            return [];
        }
    };

    return {
        selectorcode,
        nestcode,
    };
})();


export const ExcelFuntion = (() => {
    /**
     *
     */
    const ExcelToObject = async <T = any>(file: File): Promise<ResultObj<T[]>> => {
        return new Promise((resolve, reject) => {
            let Reader = new FileReader();
            Reader.onload = async (e: ProgressEvent<FileReader>) => {
                if (e.target) {
                    let data = e.target.result;
                    let wbk = XLSX.read(data, {
                        type: "binary",
                    });
                    let persons: Array<any> = [];
                    persons = persons.concat(
                        XLSX.utils.sheet_to_json(wbk.Sheets[wbk.SheetNames[0]])
                    );
                    // }
                    if (persons.length !== 0) {
                        console.log(
                            "檔案處理中，請稍後... 提醒您，依照資料多寡等待時間會不同喔! :)"
                        );
                        setTimeout(
                            () =>
                                resolve({ success: true, message: "讀取成功", data: persons }),
                            1000
                        );
                    } else resolve({ success: true, message: "讀取成功", data: [] });
                } else {
                    console.error("esd error! filereader onload error");
                    reject({
                        result: false,
                        message: "FileReader 檔案讀取錯誤",
                        data: [],
                    });
                }
            };
            Reader.readAsBinaryString(file);
        });
    };

    return {
        ExcelToObject,
    };
})();

/**
 * @description Excel 處理
 */
export const ExcelFuns = (() => {
    /**
     * Excel內容轉換
     */
    const ExcelToObject = async (inputID: string): Promise<any[]> => {
        return new Promise((resolve, reject) => {
            let ExcelFile: HTMLElement | null = document.getElementById(inputID);
            if (ExcelFile instanceof HTMLInputElement) {
                const files = ExcelFile.files;
                // 使用 files 進行相關操作
                if (files !== null && files.length > 0) {
                    let Reader = new FileReader();
                    let File = files[0];
                    Reader.onload = async (e: ProgressEvent<FileReader>) => {
                        if (e.target) {
                            let data = e.target.result;
                            let wbk = XLSX.read(data, {
                                type: "binary",
                            }),
                                persons: Array<any> = [];
                            // 20221021 Beck 讀取其他sheet可能有問題，暫時改成只讀第1個sheet
                            // for (let sheet in wbk.Sheets) {
                            // Fromto = wbk.Sheets[sheet]['!ref']; //標頭數
                            let Fromto = wbk.Sheets[wbk.SheetNames[0]]["!ref"];
                            persons = persons.concat(
                                XLSX.utils.sheet_to_json(wbk.Sheets[wbk.SheetNames[0]])
                            );
                            // }
                            if (persons.length !== 0) {
                                console.log(
                                    "檔案處理中，請稍後... 提醒您，依照資料多寡等待時間會不同喔! :)"
                                );
                                setTimeout(() => resolve(persons), 1000);
                            } else resolve([]);
                        } else {
                            console.error("esd error! filereader onload error");
                            return {
                                result: false,
                                message: "FileReader 檔案讀取錯誤",
                                data: [],
                            };
                        }
                    };
                    Reader.readAsBinaryString(File);
                } else
                    return {
                        result: false,
                        message: "請選擇檔案",
                        data: [],
                    };
            }
        });
    };

    /**
     * Excel內容轉換
     */
    const ExcelDataToObject = async (filesObj: File | null): Promise<any[]> => {
        return new Promise((resolve, reject) => {
            if (filesObj !== null) {
                let Reader = new FileReader();
                let File = filesObj;
                Reader.onload = async (e: ProgressEvent<FileReader>) => {
                    if (e.target) {
                        let data = e.target.result;
                        let wbk = XLSX.read(data, {
                            type: "binary",
                        }),
                            persons: Array<any> = [];
                        // 20221021 Beck 讀取其他sheet可能有問題，暫時改成只讀第1個sheet
                        // for (let sheet in wbk.Sheets) {
                        // Fromto = wbk.Sheets[sheet]['!ref']; //標頭數
                        let Fromto = wbk.Sheets[wbk.SheetNames[0]]["!ref"];
                        persons = persons.concat(
                            XLSX.utils.sheet_to_json(wbk.Sheets[wbk.SheetNames[0]])
                        );
                        // }
                        if (persons.length !== 0) {
                            console.log(
                                "檔案處理中，請稍後... 提醒您，依照資料多寡等待時間會不同喔! :)"
                            );
                            setTimeout(() => resolve(persons), 1000);
                        } else resolve([]);
                    } else {
                        console.error("esd error! filereader onload error");
                        return {
                            result: false,
                            message: "FileReader 檔案讀取錯誤",
                            data: [],
                        };
                    }
                };
                Reader.readAsBinaryString(File);
            } else
                return {
                    result: false,
                    message: "請選擇檔案",
                    data: [],
                };
        });
    };

    /**
     * Table轉Excel(xls)
     * @param {string} Name 表格名稱
     * @param {object} dt obj物件
     */
    const ExportToExcel = async (Name: string, dt: any) => {
        dt.attr("border", "1");
        dt.find("tr").addClass("bg-white");
        let html = dt[0].outerHTML;
        //window.open('data:application/vnd.ms-excel,' + '\uFEFF' + encodeURIComponent(html));
        let aLink = document.createElement("a");
        let evt = document.createEvent("HTMLEvents");
        evt.initEvent("click");
        aLink.download = `${Name}.xls`;
        aLink.href = `data:application/vnd.ms-excel,\uFEFF${encodeURIComponent(
            html
        )}`;
        aLink.dispatchEvent(evt);
        aLink.click();
        aLink.remove();
        dt.removeAttr("border");
        dt.find("tr").removeClass("bg-white");
    };

    /**
     * Table轉Excel(xlsx)
     * @param {string} TableName
     * @param {string} FileName
     * @param {string} type
     * @param {*} fn
     * @param {*} dl
     * 因為sheet:FileName 參數似乎不是很確定，先註解需要再說
     *
     */
    // const ExcelToXlsx = async (TableName: string, FileName: string, type:any, fn: any, dl: any) => {
    //     let elt = document.getElementById(TableName);
    //     let wb = XLSX.utils.table_to_book(elt, { sheet: FileName });
    //     wb['!cols'] = [{ wpx: 30 }];
    //     wb = wb;
    //     return dl ?
    //         XLSX.write(wb, { bookType: type, bookSST: true, type: 'base64' }) :
    //         XLSX.writeFile(wb, fn || (`${FileName}.` + (type || 'xlsx')));
    // }

    return {
        ExcelToObject,
        ExcelDataToObject,
        ExportToExcel,
        // ExcelToXlsx,
    };
})();

export const valueIsValid = (value: any) =>
    value !== "" && value !== null && value !== undefined;


/**
 * @author Olar
 * @description 來自DDMenu的各種選單 
 * // TODO 目前會不確定選單儲存狀況, 待改成 function 執行再 call
 */
export const DDMenu_codelist = (async () => {

    /*** @description 公司 */
    let codeList_COM: OptionListType<'sps_id'>[] =
        await DDMenu.selectorcode<DDMenuItem>({ spp_id: "COM" }).then(res => {
            return res.map(ele => { return { name: ele.name, sps_id: ele.sps_id } });
        });

    /*** @description 高階管理階層（前總經理室） */
    let codeList_GMO: OptionListType<'sps_id'>[] =
        await DDMenu.selectorcode<DDMenuItem>({ spp_id: "GMO" }).then(res => {
            return res.map(ele => { return { name: ele.name, sps_id: ele.sps_id } });
        });

    /*** @description 部門 */
    let codeList_DEP: OptionListType<'sps_id'>[] =
        await DDMenu.selectorcode<DDMenuItem>({ spp_id: "DEP" }).then(res => {
            return res.map(ele => { return { name: ele.name, sps_id: ele.sps_id } });
        });

    /*** @description 廠別 */
    let codeList_POS: OptionListType<'sps_id'>[] =
        await DDMenu.selectorcode<DDMenuItem>({ spp_id: "POS" }).then(res => {
            return res.map(ele => { return { name: ele.name, sps_id: ele.sps_id } });
        });

    /*** @description 課級 */
    let codeList_CLA: OptionListType<'sps_id'>[] =
        await DDMenu.selectorcode<DDMenuItem>({ spp_id: "CLA" }).then(res => {
            return res.map(ele => { return { name: ele.name, sps_id: ele.sps_id } });
        });

    /*** @description 組級 */
    let codeList_GRP: OptionListType<'sps_id'>[] =
        await DDMenu.selectorcode<DDMenuItem>({ spp_id: "GRP" }).then(res => {
            return res.map(ele => { return { name: ele.name, sps_id: ele.sps_id } });
        });

    /*** @description 辦公室 */
    let codeList_OFC: OptionListType<'sps_id'>[] =
        await DDMenu.selectorcode<DDMenuItem>({ spp_id: "OFC" }).then(res => {
            return res.map(ele => { return { name: ele.name, sps_id: ele.sps_id } });
        });

    /*** @description 薪水種類 */
    let codeList_SAL: OptionListType<'sps_id'>[] =
        await DDMenu.selectorcode<DDMenuItem>({ spp_id: "SAL" }).then(res => {
            return res.map(ele => { return { name: ele.name, sps_id: ele.sps_id } });
        });

    /*** @description 班別標籤 */
    let codeList_SCL: OptionListType<'sps_id'>[] =
        await DDMenu.selectorcode<DDMenuItem>({ spp_id: "SCL" }).then(res => {
            return res.map(ele => { return { name: ele.name, sps_id: ele.sps_id } });
        });

    /*** @description 規則檢查類型 */
    let codeList_WRS: OptionListType<'sps_id'>[] =
        await DDMenu.selectorcode<DDMenuItem>({ spp_id: "WRS" }).then(res => {
            return res.map(ele => { return { name: ele.name, sps_id: ele.sps_id } });
        });

    /*** @description 職稱 */
    let codeList_JTT: OptionListType<'sps_id'>[] =
        await DDMenu.selectorcode<DDMenuItem>({ spp_id: "JTT" }).then(res => {
            return res.map(ele => { return { name: ele.name, sps_id: ele.sps_id } });
        });

    /*** @description 職務審核設定的種類 */
    let codeList_LAT: OptionListType<'sps_id'>[] =
        await DDMenu.selectorcode<DDMenuItem>({ spp_id: "LAT" }).then(res => {
            return res.map(ele => { return { name: ele.name, sps_id: ele.sps_id } });
        });

    /*** @description 系統登入 */
    let codeList_SYS: OptionListType<'sps_id'>[] =
        await DDMenu.selectorcode<DDMenuItem>({ spp_id: "SYS" }).then(res => {
            return res.map(ele => { return { name: ele.name, sps_id: ele.sps_id } });
        });

    /*** @description 性別 */
    let codeList_SEX: OptionListType<'sps_id'>[] =
        await DDMenu.selectorcode<DDMenuItem>({ spp_id: "SEX" }).then(res => {
            return res.map(ele => { return { name: ele.name, sps_id: ele.sps_id } });
        });


    return {
        codeList_COM,
        codeList_GMO,
        codeList_DEP,
        codeList_POS,
        codeList_CLA,
        codeList_GRP,
        codeList_OFC,
        codeList_SAL,
        codeList_SCL,
        codeList_WRS,
        codeList_JTT,
        codeList_LAT,
        codeList_SYS,
        codeList_SEX
    }
})()

/** 資料更新型態 */
export enum UpdateType {
    /** 新增 */
    ADD = "Add",
    /** 更新 */
    UPDATE = "Update",
    /** 刪除 */
    DELETE = "Delete",
    /** 無更改 */
    INFO = 'Info',
}